import {IDS} from '../requirements-assessment-action-id.constants';
import {TYPES} from "../requirements-assessment-action-type.constants";
import * as Actions from '../requirements-assessment.actions';
import * as AccAction from '../../accreditation.actions';
import {GRID_FILTER} from "../../../../common/grid/grid.constants";
import get from 'lodash/get';
import moment from "moment";

class EvidenceGroupHistoryController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $filter,
                $timeout,
                $transitions,
                Notifier,
                DocumentManager,
                EmployeeService,
                AuthService,
                FileActions) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$transitions = $transitions;
        this.Notifier = Notifier;
        this.DocumentManager = DocumentManager;
        this.EmployeeService = EmployeeService;
        this.AuthService = AuthService;
        this.FileActions = FileActions;
        this.identifier = IDS.rcoRequirementsAssessment;
    }

    $onInit() {
        this.schemeCode         = this.$stateParams.itemCode;
        this.adoId              = this.$stateParams.ado;
        this.sloFiscalYear      = this.$stateParams.year;
        this.isAdmin = this.AuthService.getUser().type === 'Administrator';

        this.unsubscribe = this.$ngRedux.connect(state => {
            const accDashboardLocationYear = state.accreditation.accDashboardLocationYear;
            const subModule = state.accreditation.rcoRequirementsAssessment;
            const details = subModule.evidenceDetails;
            const locationName = subModule.selectedSiteLocation?.locationName
            const locationUuid = subModule.selectedSiteLocation?.uuid
            const section = state.accreditation.selectedRequirement;
            return {
                details,
                reviewAssignee: details.reviewAssignee?.employee_uuid,
                reviewComment: details.reviewComment,
                sectionNumber:      get(details,'sectionName','').split(' ')[0],
                sectionName:        get(details,'sectionName','').split(' ')[0],
                sectionDescription: get(section,'description','')?.replace(/\n/g,'<br>'),
                fiscalYear:         accDashboardLocationYear.year,
                locationName,
                locationUuid,
                section,
            }
        }, {
            ...AccAction,
            ...Actions,
            ...this.FileActions,
        })(this);

        this.onEnterUnsubscribe = this.$transitions.onEnter({
            to: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_details
        }, () => {
            this.selectedPanel = undefined;
            if(this.locationUuid) {
                this.$ngRedux.dispatch({
                    type: GRID_FILTER,
                    id: IDS.rcoRequirementsAssessment,
                    path: IDS.rcoEvidenceGroupHistoryGrid,
                    filter: {
                        ase_id: this.section?.id,
                        slo_uuid: this.locationUuid,
                        year: this.fiscalYear,
                        ard_id: this.details.ard_id
                    }
                });
            }
        });
    }

    $onDestroy() {
        this.unsubscribe();
        this.onEnterUnsubscribe();
    }
}

EvidenceGroupHistoryController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$filter',
    '$timeout',
    '$transitions',
    'Notifier',
    'DocumentManager',
    'EmployeeService',
    'AuthService',
    'FileActions']

export const evidenceGroupHistory = {
    controller: EvidenceGroupHistoryController,
    template: `
        <div class="formHeader" layout-align="start center" flex>
            <h3>
                <div layout="row" layout-align="start center">
                    <asset cls="colorAccreditations" src="rco-evidence-icon.svg"></asset>
                    <div style="padding-left: 5px;">{{$ctrl.details.doc_num}} - {{$ctrl.details.name}}</div>
                </div>
            </h3>
        </div>
        <div hide-md hide-sm hide-xs > </div>
        <div style="padding-left: 20px;">{{$ctrl.details.description}}
            <md-tooltip ng-if="$ctrl.filenameTooltip">{{$ctrl.filenameTooltip}}</md-tooltip>
        </div>
        <div layout-margin></div>
        <evidence-group-history-grid></evidence-group-history-grid>
`
}
